import { mapGetters, mapActions } from 'vuex'
import Events from '@/core/service/events'
import variables from '@/assets/styles/helpers/_variables.scss'
import moment from 'moment'

export default  {
  data: () => ({
    page: 1,
    search: '',
    activeModal: false,
    filter: ''
  }),

  mounted () {
    Events.$on('toolbar::selectFilter', (val) => { this.selectFilter = val })
    Events.$on('paginacao::clear', () => { this.page = 1 })
  },

  computed: {
    ...mapGetters('globalStore', ['isStatus']),
    ...mapGetters('roles', ['permiteAcao']),
    ...mapGetters('filter', ['objFilter']),
    ...mapGetters('entities', ['listEntityTypes']),
    variables: () => variables,
    numberOfPages () {
      return Math.ceil(this.totalExtratoCreditos / this.$store.getters.ItensPaginacao)
    },

    itemsPerPage () {
      return this.$store.getters.ItensPaginacao
    },

    pageStop () {
      const result = this.$store.getters.ItensPaginacao * this.page
      return result < this.totalExtratoCreditos ? result : this.totalExtratoCreditos
    },

    pageStart () {
      return this.pageStop - this.listExtratoCredito.length + 1
    }
  },

  watch: {
    page (e) {
      this.paginacao(e)
    }
  },

  created () {
    this.init()
  },

  methods: {
    // mapeando as actions de tratamento de filtro
    ...mapActions('filter', ['clearObjFilter']),
    ...mapActions('globalStore', ['switchStatus', 'clearSwitchStatus']),
    // mapeando as actions pra salvar na store o numero da pagina das tabelas
    ...mapActions('pagination', ['setPage', 'clearPage'] // limpa os dados da paginação
    ),

    paginacao (pag) {
      this.setPage(pag)
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      this.$emit('obterExtratoPorData', this.rangeDate, pag)
    },

    getColor (date, inverso = false) {
      return (inverso ? !this.getStatus(date) : this.getStatus(date))  ? this.variables.colorSecondary : this.variables.colorError
    },

    getStatus (date) {
      return moment(date, 'YYYY-MM-DD').isSame(moment('1970-01-01'), 'year') ? !!1 : !!0
    },

    textStatus (date) {
      return this.getStatus(date) ? 'Ativo' : 'Inativo'
    },

    getEntityType (id) {
      let str = this.listEntityTypes.filter(item => item.id === id)[0].text
      str = str.toLowerCase()
      str = str.charAt(0).toUpperCase() + str.substr(1)

      return str
    }
  },
  beforeDestroy () {
    this.clearSwitchStatus()
    this.clearItens() // limpa os dados da tabela
    this.clearObjFilter() // limpa os dados do modal de filtro
    this.clearPage() // limpa os dados da paginação
    this.objCampoBusca = [] // limpa os dados do campo de busca
    Events.$off('toolbar::selectFilter')
    Events.$off('toolbar::selectFilter')
    Events.$off('paginacao::clear')
  }
}